import randomSort from '@/helpers/randomSort';
import api from '@/store/helpers/api';

const SUCCESS_SCORE = 12;

const initialState = {
  list: [],
  score: 0,
  loading: false,
  gameEnded: false,
  isOver: false,
};

const getters = {
  current(state) {
    const current = state.list.length - 1;
    return state.list[current];
  },
  score(state) {
    return `${state.score}`;
  },
};

const actions = {
  get({ state, commit, dispatch }) {
    commit('LOADSTART');
    let url = '/quiz/remaining';
    if (state.isOver) {
      url = '/quiz';
    }
    return api.get(url)
      .then((data) => {
        if (data && data.length === 0) {
          commit('IS_OVER');
          return dispatch('get');
        }

        commit('SET', data.sort(randomSort));
        return true;
      })
      .finally(() => {
        commit('LOADEND');
      });
  },
  answer({ commit, state }, { id, success }) {
    if (state.isOver) {
      return false;
    }

    commit('ANSWER', success);

    // Don't show loader, since it's an async request
    return api.post('quiz/answer', {
      points: success ? SUCCESS_SCORE : 0,
      id,
      success,
    });
    // return id;
  },
  next({ commit }) {
    commit('NEXT');
  },
  reset({ commit }) {
    commit('RESET');
  },
};

const mutations = {
  LOADSTART(state) {
    state.loading = true;
  },
  LOADEND(state) {
    state.loading = false;
  },
  SET(state, list) {
    state.list = list;
  },
  IS_OVER(state) {
    state.isOver = true;
  },
  ANSWER(state, success) {
    if (success) {
      state.score += SUCCESS_SCORE;
    }
  },
  NEXT(state) {
    state.list.splice(state.list.length - 1, 1);
  },
  RESET(state) {
    state.list = [];
    state.score = 0;
    state.loading = false;
    state.gameEnded = false;
    state.isOver = false;
  },
};

// Export store
export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
